<template>
  <div id="app" data-server-rendered="true">
    <!-- 1.头部导航 -->
    <yp-navbar ref="navbar" class="no-transparent-navbar" mobileTitle="荣誉资质"></yp-navbar>
    <!-- 2.背景图 + 标题 -->
    <!-- <div class="title-bg">
      <div class="container">
        <div class="title-container">
          <div class="img-a">
            <img src="/static/images/font-a.png" draggable="false" alt="a">
          </div>
          <div class="title-font">
            <div class="title-en">BOUT US</div>
            <div class="title-zh">走进悦朋</div>
          </div>
        </div>
      </div>
    </div> -->
    <page-title-bg first-font="a" title-en="BOUT US" title-zh="走进悦朋"></page-title-bg>
    <!-- 3.面包屑导航 -->
    <div class="bread-crumbs-container hidden-xs">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/companyProfile.html">走进悦朋</a></li>
          <li class="active">荣誉资质</li>
        </ol>
      </div>
    </div>
    <!-- 4.企业简介 -->
    <section class="enterprise-profile-container">
      <div class="enterprise-profile-box" id="enterpriseProfileBox">
        <!-- 知识产权 -->
        <div class="sec-title-container">
          <div class="sec-title-zh">知识产权</div>
          <div class="sec-title-en">INTELLECTUAL PROPERTY</div>
        </div>
        <div class="container-img-box">
          <div class="img-box-content" v-for="(item, index) in certificateListNowList" :key="index">
            <div class="content-img home-page" data-toggle="modal" data-target="#myModal" @click="showDialog(index, certificateListNowList, certificateList)">
              <img v-lazy="item.img" alt="" />
            </div>
            <div class="certificate-title">{{ item.title }}</div>
          </div>
        </div>
        <div class="pagenation">
          <nav aria-label="Page navigation" class="pagenation-class">
            <div class="home-page" @click="jumpEvent(1)">首页</div>
            <ul class="pagination">
              <li>
                <a aria-label="Previous" @click="pageDelete" class="pagination-left">
                  <div aria-hidden="true" class="glyphicon glyphicon-menu-left"></div>
                </a>
              </li>
              <li v-for="(item, index) in Math.ceil(certificateList.length / 8)" :key="index">
                <a :class="pageNow === index + 1 ? 'color-class' : ''" @click="jumpEvent(index + 1)">{{ index + 1 }}</a>
              </li>
              <li>
                <a aria-label="Next" @click="pageAdd">
                  <span aria-hidden="true" class="glyphicon glyphicon-menu-right"></span>
                </a>
              </li>
            </ul>
            <div class="end-page" @click="jumpEvent(Math.ceil(certificateList.length / 8))">末页</div>
            <div class="page-all-class">共 {{ Math.ceil(certificateList.length / 8) }} 页</div>
          </nav>
        </div>
        <!-- 其他荣誉 -->
        <div class="sec-title-container">
          <div class="sec-title-zh">其他荣誉</div>
          <div class="sec-title-en">OTHER HONORS</div>
        </div>
        <div class="container-img-box">
          <div class="img-box-content" v-for="(item, index) in certificateListNowListSecond" :key="index">
            <div class="content-img home-page" data-toggle="modal" data-target="#myModal" @click="showDialog(index, certificateListSecond, certificateListSecond)">
              <img class="content-second-img" v-lazy="item.img" alt="" />
            </div>
            <div class="certificate-title">{{ item.title }}</div>
          </div>
        </div>
        <div class="pagenation">
          <nav aria-label="Page navigation" class="pagenation-class">
            <div class="home-page" @click="jumpEventsecond(1)">首页</div>
            <ul class="pagination">
              <li>
                <a aria-label="Previous" @click="pageDeleteSecond" class="pagination-left">
                  <span aria-hidden="true" class="glyphicon glyphicon-menu-left"></span>
                </a>
              </li>
              <li v-for="(item, index) in Math.ceil(certificateListSecond.length / 8)" :key="index">
                <a :class="pageNowsecond === index + 1 ? 'color-class' : ''" @click="jumpEventsecond(index + 1)">{{ index + 1 }}</a>
              </li>
              <li>
                <a aria-label="Next" @click="pageAddSecond">
                  <span aria-hidden="true" class="glyphicon glyphicon-menu-right"></span>
                </a>
              </li>
            </ul>
            <div class="end-page" @click="jumpEventsecond(Math.ceil(certificateListSecond.length / 8))">末页</div>
            <div class="page-all-class">共 {{ Math.ceil(certificateListSecond.length / 8) }} 页</div>
          </nav>
        </div>
      </div>
    </section>
    <!-- 动态弹框 -->
    <!-- Button trigger modal -->
    <!-- Modal -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="model-class">
        <div class="home-page button-right" @click="modelPrevious(modelImgForm.index, modelImgForm.list)">
          <img src="../../../public/static/img/buttonleft.png" alt="" />
        </div>
        <div class="modal-dialog" role="document">
          <img class="modal-dialog-img" :src="modelImgForm.img" alt="" />
          <img class="close-button" data-dismiss="modal" src="../../../public/static/img/closeButton.png" alt="" />
        </div>
        <div class="home-page button-right" @click="modelNext(modelImgForm.index, modelImgForm.list)">
          <img src="../../../public/static/img/buttonright.png" alt="" />
        </div>
      </div>
      <div class="model-title">{{ modelImgForm.title }}</div>
    </div>
    <!-- 7.footer -->
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    YpFooter,
  },

  data() {
    return {
      pageNow: 1, //  当前分页
      pageNowsecond: 1, //  当前分页
      certificateList: [
        {
          img: require('../../../public/static/img/honorary2.jpg'),
          // imgSecond: require('../../../public/static/img/honorary2.jpg'),
          title: '工作流引擎系统',
        },
        {
          img: require('../../../public/static/img/honorary3.jpg'),
          title: '购物中心数字化运营平台',
        },
        {
          img: require('../../../public/static/img/ruleEngine.jpg'),
          title: '规则引擎中间件',
        },
        {
          img: require('../../../public/static/img/IntegrationEngine.jpg'),
          title: '集成引擎中间件',
        },
        {
          img: require('../../../public/static/img/honorary5.jpg'),
          title: '开发运维平台',
        },
        {
          img: require('../../../public/static/img/retail.jpg'),
          title: '零售业数字化平台',
        },
        {
          img: require('../../../public/static/img/communitysupply.jpg'),
          title: '社群供应链平台',
        },
        {
          img: require('../../../public/static/img/communitMarketing.jpg'),
          title: '社群营销平台',
        },
        {
          img: require('../../../public/static/img/dataplatform.jpg'),
          title: '数据平台',
        },
        {
          img: require('../../../public/static/img/userportrait.jpg'),
          title: '用户画像',
        },
        {
          img: require('../../../public/static/img/userauthentication.jpg'),
          title: '用户认证',
        },
        {
          img: require('../../../public/static/img/chedulingmiddlewaresystem.jpg'),
          title: '悦朋零售数字化平台调度中间件系统',
        },
        {
          img: require('../../../public/static/img/retaildigitalplatform.jpg'),
          title: '悦朋零售数字化平台消息中间件系统',
        },
        {
          img: require('../../../public/static/img/paymentgateway.jpg'),
          title: '悦朋零售数字化平台支付网关系统',
        },
        {
          img: require('../../../public/static/img/platformmembercenter.jpg'),
          title: '悦朋数字化平台会员中心管理系统',
        },
        {
          img: require('../../../public/static/img/cloudPOSplatform.jpg'),
          title: '智慧零售云POS平台',
        },
      ],
      certificateListSecond: [
        {
          img: require('../../../public/static/img/newTechnology.jpg'),
          title: '高新技术',
        },
      ],
      certificateListNowList: [],
      certificateListNowListSecond: [],
      modelImgForm: {},
    }
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
    this.pageCount()
    this.pageCountSecond()
    this.$nextTick(() => {
      if (document.documentElement.clientWidth > 1000) {
        document.getElementById('enterpriseProfileBox').style.padding = `0 ${this.rateNumber(0.08) * 100}%`
      }
      if (document.documentElement.clientWidth > 1680) {
        document.getElementById('enterpriseProfileBox').style.padding = `0 ${this.rateNumber(0.15) * 100}%`
      }
    })
  },
  methods: {
    rateNumber(val) {
      // val 当前分辨率对应的值
      // 获取当前那屏幕的宽度
      var number = document.documentElement.clientWidth
      // 对应的比例
      var rateNumber = (number * val) / 1920
      return rateNumber
    },
    //   计算当前的展示信息
    pageCount() {
      var pageBagin = (this.pageNow - 1) * 8
      var pageEnd = pageBagin + 7
      this.certificateListNowList = this.certificateList.filter((item, index) => {
        return index >= pageBagin && index <= pageEnd
      })
    },
    pageCountSecond() {
      var pageBagin = (this.pageNowsecond - 1) * 8
      var pageEnd = pageBagin + 7
      this.certificateListNowListSecond = this.certificateListSecond.filter((item, index) => {
        return index >= pageBagin && index <= pageEnd
      })
    },
    // 下一页
    pageAdd() {
      if (this.pageNow === Math.ceil(this.certificateList.length / 8)) {
        // 最后一页
      } else {
        this.pageNow++
        this.pageCount()
      }
    },
    pageAddSecond() {
      if (this.pageNowsecond === Math.ceil(this.certificateListSecond.length / 8)) {
        // 最后一页
      } else {
        this.pageNowsecond++
        this.pageCountSecond()
      }
    },
    pageDelete() {
      if (this.pageNow === 1) {
        // 最后一页
      } else {
        this.pageNow--
        this.pageCount()
      }
    },
    pageDeleteSecond() {
      if (this.pageNowsecond === 1) {
        // 最后一页
      } else {
        this.pageNowsecond--
        this.pageCountSecond()
      }
    },
    jumpEvent(e) {
      this.pageNow = e
      this.pageCount()
    },
    jumpEventsecond(e) {
      this.pageNowsecond = e
      this.pageCountSecond()
    },
    // 展开图片
    showDialog(index, element, list) {
      this.modelImgForm = element[index]
      this.modelImgForm.index = index
      this.modelImgForm.list = list
      // 点击当前图片的index, 和渲染的list列表
    },
    modelNext(index, list) {
      // 下一张
      if (index + 1 <= list.length) {
        this.modelImgForm = list[index + 1]
        this.modelImgForm.index = index + 1
        this.modelImgForm.list = list
      }
    },
    modelPrevious(index, list) {
      // 下一张
      if (index >= 1) {
        this.modelImgForm = list[index - 1]
        this.modelImgForm.index = index - 1
        this.modelImgForm.list = list
      }
    },
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
